
// import parameterMessages from 'domain/Options/parameterMessages';
import messages from './messages/overhangMessages';
import BarOneCutSmall from './images/overhangs/Bar_OneCut_384x212.png';
import BarOneCutBig from './images/overhangs/Bar_OneCut_500x500.png';
import BarOneRoundSmall from './images/overhangs/Bar_OneRound_384x212.png';
import BarOneRoundBig from './images/overhangs/Bar_OneRound_500x500.png';
import BarRoundedSmall from './images/overhangs/Bar_TwoRound_384x212.png';
import BarRoundedBig from './images/overhangs/Bar_TwoRound_500x500.png';
import BarArcSmall from './images/overhangs/Bar_Rounded_384x212.png';
import BarArcBig from './images/overhangs/Bar_Rounded_500x500.png';
import BarTwoCutsSmall from './images/overhangs/Bar_TwoCuts_384x212.png';
import BarTwoCutsBig from './images/overhangs/Bar_TwoCuts_500x500.png';
import BarWaterfall1Small90Deg from './images/overhangs/Bar_waterfall_1_384x212.png';
import BarWaterfall1Big90Deg from './images/overhangs/Bar_waterfall_1_500x500.png';
import BarWaterfall2Small90Deg from './images/overhangs/Bar_waterfall_2_384x212.png';
import BarWaterfall2Big90Deg from './images/overhangs/Bar_waterfall_2_500x500.png';
import BarNoCutsBig from './images/overhangs/Bar_NoCut_500x500.png';
import BarNoCutsSmall from './images/overhangs/Bar_NoCut_384x212.png';
import BarWaterfall1Small45Deg from './images/overhangs/Bar_waterfall_90_1_384x212.png';
import BarWaterfall1Big45Deg from './images/overhangs/Bar_waterfall_90_1_500x500.png';
import BarWaterfall2small45Deg from './images/overhangs/Bar_waterfall_90_2_384x212.png';
import BarWaterfall2Big45Deg from './images/overhangs/Bar_waterfall_90_2_500x500.png';


import BarOneCutPictogram from './images/overhangs/Pictograms/picto_PLAN_bar_one_cut.png';
import BarOneRoundPictogram from './images/overhangs/Pictograms/picto_PLAN_bar_one_round.png';
import BarRoundedPictogram from './images/overhangs/Pictograms/picto_PLAN_bar_rounded.png';
import BarTwoRoundPictogram from './images/overhangs/Pictograms/picto_PLAN_bar_two_round_v2.png';
import BarTwoCutsPictogram from './images/overhangs/Pictograms/picto_PLAN_bar_two_cuts.png';
import BarWaterfallPictogram from './images/overhangs/Pictograms/picto_PLAN_bar_waterfall.png';

export const NO_OVERHANG_ID = 'no-overhang';
export const WATERFALL_ID_45_DEGREES = 'waterfall-45-degrees';
export const WATERFALL_WITH_OVERHANG_ID_45_DEGREES = 'waterfall-with-overhang-45-degrees';
export const WATERFALL_ID_90_DEGREES = 'waterfall-90-degrees';
export const WATERFALL_WITH_OVERHANG_ID_90_DEGREES = 'waterfall-with-overhang-90-degrees';
export const ROUNDED_OVERHANG_ID = 'rounded';
export const HALF_ROUNDED_OVERHANG_ID = 'half-rounded';
export const EMERALD_ID = 'emerald';
export const HALF_EMERALD_ID = 'half-emerald';
export const ARC_ID = 'arc';

export const availableOverhangs = {
  noOverhang: {
    id: NO_OVERHANG_ID,
    displayName: messages.noOverhang,
  },
  'waterfall-45-degrees': {
    displayName: messages.waterfall45Degrees,
    displayImage: BarWaterfall1Small45Deg,
    displayImageLarge: BarWaterfall1Big45Deg,
    pictogramImage: BarWaterfallPictogram,
  },
  'waterfall-with-overhang-45-degrees': {
    displayName: messages.waterfallWithOverhang45Degrees,
    displayImage: BarWaterfall2small45Deg,
    displayImageLarge: BarWaterfall2Big45Deg,
    pictogramImage: BarWaterfallPictogram,
  },
  'waterfall-90-degrees': {
    displayName: messages.waterfall90Degrees,
    displayImage: BarWaterfall1Small90Deg,
    displayImageLarge: BarWaterfall1Big90Deg,
    pictogramImage: BarWaterfallPictogram,
  },
  'waterfall-with-overhang-90-degrees': {
    displayName: messages.waterfallWithOverhang90Degrees,
    displayImage: BarWaterfall2Small90Deg,
    displayImageLarge: BarWaterfall2Big90Deg,
    pictogramImage: BarWaterfallPictogram,
  },
  arc: {
    displayName: messages.arc,
    displayImage: BarArcSmall,
    displayImageLarge: BarArcBig,
    pictogramImage: BarRoundedPictogram,
    operations: ['roundedCorner'],
  },
  rounded: {
    displayName: messages.twoRounded,
    displayImage: BarRoundedSmall,
    displayImageLarge: BarRoundedBig,
    pictogramImage: BarTwoRoundPictogram,
    operations: ['roundedCorner', 'roundedCorner'],
  },
  'half-rounded': {
    displayName: messages.oneRounded,
    displayImage: BarOneRoundSmall,
    displayImageLarge: BarOneRoundBig,
    pictogramImage: BarOneRoundPictogram,
    operations: ['roundedCorner'],
  },
  emerald: {
    displayName: messages.emerald,
    displayImage: BarTwoCutsSmall,
    displayImageLarge: BarTwoCutsBig,
    pictogramImage: BarTwoCutsPictogram,
    operations: ['singleCut', 'singleCut'],
  },
  'half-emerald': {
    displayName: messages.halfEmerald,
    displayImage: BarOneCutSmall,
    displayImageLarge: BarOneCutBig,
    pictogramImage: BarOneCutPictogram,
    operations: ['singleCut'],
  },
  'no-corner-cut': {
    displayName: messages.noCorners,
    displayImage: BarNoCutsSmall,
    displayImageLarge: BarNoCutsBig,
    pictogramImage: BarWaterfallPictogram,    
  },
};

const overhangOptions = (overhangs) => {
  return [availableOverhangs.noOverhang].concat(
    overhangs.filter((overhang) => {
      if (!availableOverhangs[overhang.id]) {
        // eslint-disable-next-line no-console
        console.error('Excluding unknown overhang:', overhang.id);
        return false;
      }

      if (!overhang.allowedMaterials || overhang.allowedMaterials.length === 0) {
        // eslint-disable-next-line no-console
        console.error('Excluding overhang', overhang.id, 'due to no allowed materials:', overhang.id);
        return false;
      }

      return true;
    })
    .map(({ id, allowedMaterials, minLength }) => ({
      id,
      allowedMaterials,
      minLength,
      ...availableOverhangs[id],
    }))
  );
};

export function generateOverhangs({ overhangs, overhangDefaultSize, waterfallHeight, overhangLegRequirements }) {
  const includeOverhangs = overhangs && overhangs.length !== 0;

  if (!includeOverhangs) {
    return { includeOverhangs, options: [availableOverhangs.noOverhang] };
  }

  const defaultSize = overhangDefaultSize || 500;
  if (!overhangDefaultSize) {
    // eslint-disable-next-line no-console
    console.error(`Setting overhang default size to ${defaultSize} due to overhangDefaultSize not in rules`);
  }

  const defaultHeight = waterfallHeight || 880;
  if (!waterfallHeight) {
    // eslint-disable-next-line no-console
    console.error(`Setting waterfall height to ${defaultHeight} due to waterfallHeight not in rules`);
  }
  return {
    includeOverhangs,
    waterfallHeight: defaultHeight,
    overhangDefaultSize: defaultSize,
    overhangLegRequirements,
    options: overhangOptions(overhangs),
  };
}

export const test = {
  overhangOptions,
};
